<script>
    import {
        health,
        energy,
        hygiene,
        culture,
        iq,
        loneliness,
        confidence,
        stress,
        alcoholism,
        drugs,
        smooth,
        honesty,
        optimism,
        fitness,
        money,
        time,
        date,
        home_cleanliness,
        TimeEnum,
        TimeToPrint,
        upcomingEvent,
        Item,
        energy_geq_10,
        energy_geq_20,
        modal,
        daysElapsed,
        times_stared_at_walls,
        ItemCategoryEnum,
        have_cube,
        have_burbon,
        have_rollers,
        have_camera,
        have_tv,
        media,
        journalism,
        meditation,
        welding,
        basic_cooking,
        basic_law,
        people_skills,
        public_speaking,
        police_experience,
        italian,
        french,
        have_microwave,
        have_boardgame,
        have_recordplayer,
        have_bass,
        have_usedbass,
        have_guitar,
        have_usedguitar,
        have_drums,
        have_useddrums,
        have_piano,
        have_sax,
        have_usedsax,
        have_keyboard,
        bass,
        guitar,
        drums,
        keys,
        sax,
        book_iq,
        book_hgg,
        book_wshp,
        book_shining,
        book_meditation,
        book_welding,
        book_confidence,
        book_cooking,
        book_history,
        book_speak,
        book_encyclopedia,
        book_law,
        book_italian,
        book_french,
        book_peopleskills, book_sherlock,
        progressTime, rnd
    } from './stores.js';
    import Action_TV from "./Action_TV.svelte";
    import { withActionLog } from './actionLog.js';

    export let currentShop = null;
    export let home = false;

    $: items = [
        new Item({
            name: "Rubik's Cube",
            description: "Rubik's Cube is a 3D combination puzzle invented in 1974 by Hungarian sculptor and professor of architecture Ernő Rubik. Doing puzzles is known to improve your cognitive abilities.",
            category: ItemCategoryEnum.General,
            have: $have_cube,
            possible: $energy_geq_10,
            price: 18.99,
            buy: () => { $have_cube = true; $money -= 18.99},
            effect: () => {
                $energy -= rnd(0.06, 0.15);
                $iq += rnd(0.06, 0.08);
                $confidence += rnd(0.01, 0.03);},
        }),
        new Item({
            name: "Bottle of Bourbon",
            description: "A bottle of fine American barrel-aged distilled spirit made primarily from corn. Smooth as Sean Connery. Sip on that fine burbon not many can afford.",
            category: ItemCategoryEnum.General,
            have: $have_burbon,
            price: 38.95,
            buy: () => { $have_burbon = true; $money -= 38.95},
            effect: () => {
                $energy -= rnd(0.02, 0.04);
                $loneliness += rnd(0.05, 0.1);
                $optimism += rnd(0.1, 0.15);
                $alcoholism += rnd(0.05, 0.07);
                $smooth += rnd(0.05, 0.07)},
        }),
        new Item({
            name: "Roller Skates",
            description: "Roller skates are shoes, or bindings that fit onto shoes, that are worn to enable the wearer to roll along on wheels. Get movin with you fresh new roller skates.",
            category: ItemCategoryEnum.General,
            icon_url: "item_rollerskates.png",
            have: $have_rollers,
            possible: $energy_geq_20,
            price: 34.99,
            buy: () => { $have_rollers = true; $money -= 34.99},
            effect: () => {
                $energy -= rnd(0.09, 0.19);
                $fitness += rnd(0.03, 0.06);
                $stress -= rnd(0.06, 0.12);},
        }),
        new Item({
            name: "Polaroid Camera",
            description: "Instant photos! No more film development in the darkroom. Get out and try to capture some cool moments.",
            category: ItemCategoryEnum.General,
            have: $have_camera,
            possible: $energy_geq_20,
            price: 77.99,
            buy: () => { $have_camera = true; $money -= 77.99},
            effect: () => {
                $energy -= rnd(0.09, 0.11);
                $stress -= rnd(0.16, 0.22);
                $culture += rnd(0.04, 0.06);
                $media += rnd(0.04, 0.06);
                $journalism += rnd(0.01, 0.03);},
        }),
        new Item({
            name: "TV Set",
            description: "A complete color television set. Watch broadcasts of news, art, and cooking shows.",
            category: ItemCategoryEnum.Appliances,
            icon_url: "item_tv.png",
            have: $have_tv,
            price: 82.99,
            buy: () => { $have_tv = true; $money -= 82.99},
            effect: () => {
                $home_cleanliness -= 0.05;
                $optimism -= rnd(0.01, 0.1);
                $fitness -= 0.03;
                modal.set(Action_TV)
            },
        }),
        new Item({
            name: "Microwave oven",
            description: "The latest sci-fi technology in your kitchen, heating up meals in seconds.",
            category: ItemCategoryEnum.Appliances,
            have: $have_microwave,
            price: 69.99,
            buy: () => { $have_microwave = true; $money -= 69.99},
            // TODO: add some effect on energy or recovery or whatever...
        }),
        new Item({
            name: "Mystery Date Board Game",
            description: "Invite your friends over and have fun. The object of the game is to acquire a desirable date, while avoiding the dud.",
            category: ItemCategoryEnum.General,
            icon_url: "item_boardgame.png",
            have: $have_boardgame,
            price: 15.99,
            buy: () => { $have_boardgame = true; $money -= 15.99},
            // TODO: add social activity...
        }),
        new Item({
            name: "Vinyl Record Player",
            description: "A genuine diamon needle will give you over 50 times the life of any other type of needle.",
            category: ItemCategoryEnum.Appliances,
            icon_url: "item_recordplayer.png",
            have: $have_recordplayer,
            price: 89.99,
            buy: () => { $have_recordplayer = true; $money -= 89.99},
            effect: () => {
                $optimism += rnd(0.1, 0.3);
                $fitness -= 0.02;
                $energy += 0.05;
                $culture += rnd(0.05, 0.07);
                $smooth += rnd(0.05, 0.07);
                $stress -= rnd(0.1, 0.18);
                // TODO: maybe ad a screen for choosing records :D modal.set(...)
            },
        }),
        // Instruments
        new Item({
            name: "Bass guitar",
            description: "The backbone of the funk grooves. Slap that bass and learn how to groove.",
            category: ItemCategoryEnum.Music,
            have: $have_bass,
            price: 84.99,
            buy: () => { $have_bass = true; $money -= 84.99},
            effect: () => {
                $bass += rnd(0.03, 0.07);
                $stress -= rnd(0.1, 0.12);
                $culture += rnd(0.01, 0.07);
                $smooth += rnd(0.01, 0.07);
                $energy -= rnd(0.2, 0.3);
            },
        }),
        new Item({
            name: "Used bass guitar",
            description: "It's refurbished, but still groovin' as ever. Slap that bass and learn how to groove.",
            category: ItemCategoryEnum.Music,
            have: $have_usedbass,
            price: 55.0,
            buy: () => { $have_usedbass = true; $money -= 55.0},
            effect: () => {
                $bass += rnd(0.03, 0.07);
                $stress -= rnd(0.1, 0.12);
                $culture += rnd(0.01, 0.07);
                $smooth += rnd(0.01, 0.07);
                $energy -= rnd(0.2, 0.3);
            },
        }),
        new Item({
            name: "Electric guitar",
            description: "Riff it out and make the crowd dance. Practice those riffs if you plan on makin' it big.",
            category: ItemCategoryEnum.Music,
            have: $have_guitar,
            price: 82.99,
            buy: () => { $have_guitar = true; $money -= 82.99},
            effect: () => {
                $guitar += rnd(0.025, 0.05);
                $stress -= rnd(0.1, 0.15);
                $culture += rnd(0.01, 0.06);
                $smooth += rnd(0.01, 0.05);
                $energy -= rnd(0.2, 0.3);
            },
        }),
        new Item({
            name: "Used electric guitar",
            description: "Bit worn out, but still sounds good. Practice those riffs if you plan on makin' it big.",
            category: ItemCategoryEnum.Music,
            have: $have_usedguitar,
            price: 60.00,
            buy: () => { $have_usedguitar = true; $money -= 60.0},
            effect: () => {
                $guitar += rnd(0.025, 0.05);
                $stress -= rnd(0.1, 0.15);
                $culture += rnd(0.01, 0.06);
                $smooth += rnd(0.01, 0.05);
                $energy -= rnd(0.2, 0.3);
            },
        }),
        new Item({
            name: "Drum kit",
            description: "A one, a two, a you know what to do. Hit it! Torture neighbors and improve your chops. Paradiddle-diddle.",
            category: ItemCategoryEnum.Music,
            have: $have_drums,
            price: 218.99,
            buy: () => { $have_drums = true; $money -= 218.99},
            effect: () => {
                $drums += rnd(0.04, 0.07);
                $stress -= rnd(0.15, 0.3);
                $culture += rnd(0.01, 0.04);
                $smooth += rnd(0.01, 0.04);
                $energy -= rnd(0.2, 0.3);
            },
        }),
        new Item({
            name: "Used drums",
            description: "Bit shabby, but can still lay down the mean beat. Torture neighbors and improve your chops. Paradiddle-diddle.",
            category: ItemCategoryEnum.Music,
            have: $have_useddrums,
            price: 140.0,
            buy: () => { $have_useddrums = true; $money -= 140.0},
            effect: () => {
                $drums += rnd(0.04, 0.07);
                $stress -= rnd(0.15, 0.3);
                $culture += rnd(0.01, 0.04);
                $smooth += rnd(0.01, 0.04);
                $energy -= rnd(0.2, 0.3);
            },
        }),
        new Item({
            name: "Piano",
            description: "The grandest of them all. You gotta work those firngers.",
            category: ItemCategoryEnum.Music,
            have: $have_piano,
            price: 400.00,
            buy: () => { $have_piano = true; $money -= 400.00},
            effect: () => {
                $keys += rnd(0.0125, 0.02);
                $stress -= rnd(0.1, 0.15);
                $culture += rnd(0.01, 0.04);
                $smooth += rnd(0.01, 0.04);
                $energy -= rnd(0.2, 0.3);
            },
        }),
        new Item({
            name: "Keyboard synth",
            description: "Make the magic happen with this marvel of technology. You gotta work those firngers.",
            category: ItemCategoryEnum.Music,
            have: $have_keyboard,
            price: 156.99,
            buy: () => { $have_keyboard = true; $money -= 156.99},
            effect: () => {
                $keys += rnd(0.0125, 0.02);
                $stress -= rnd(0.1, 0.15);
                $culture += rnd(0.01, 0.04);
                $smooth += rnd(0.01, 0.04);
                $energy -= rnd(0.2, 0.3);
            },
        }),
        new Item({
            name: "Saxophone",
            description: "A tone smooth as silk. Play that funky music wild boy... or gal.",
            category: ItemCategoryEnum.Music,
            have: $have_sax,
            price: 130.99,
            buy: () => { $have_sax = true; $money -= 130.99},
            effect: () => {
                $sax += rnd(0.025, 0.035);
                $stress -= rnd(0.1, 0.15);
                $culture += rnd(0.01, 0.04);
                $smooth += rnd(0.01, 0.04);
                $energy -= rnd(0.2, 0.3);
            },
        }),
        new Item({
            name: "Used saxophone",
            description: "Dont't worry, it has been properly desinfected. Play that funky music wild boy... or gal.",
            category: ItemCategoryEnum.Music,
            have: $have_usedsax,
            price: 89.99,
            buy: () => { $have_usedsax = true; $money -= 89.99},
            effect: () => {
                $sax += rnd(0.025, 0.035);
                $stress -= rnd(0.1, 0.15);
                $culture += rnd(0.01, 0.04);
                $smooth += rnd(0.01, 0.04);
                $energy -= rnd(0.2, 0.3);
            },
        }),
        // BOOKS
        new Item({
            name: "The Hitchhiker's Guide to the Galaxy",
            description: "Seconds before the Earth is demolished to make way for a galactic freeway, Arthur Dent is plucked off the planet by his friend Ford Prefect.",
            category: ItemCategoryEnum.Books,
            have: $book_hgg,
            price: 12.99,
            buy: () => { $book_hgg = true; $money -= 12.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $culture += rnd(0.04, 0.06);
                $iq += rnd(0.01, 0.035);
            },
        }),
        new Item({
            name: "Watership Down",
            description: "Set in England's Downs, a once idyllic rural landscape, this stirring tale of adventure, courage and survival follows a band of very special creatures.",
            category: ItemCategoryEnum.Books,
            have: $book_wshp,
            price: 8.99,
            buy: () => { $book_wshp = true; $money -= 8.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $culture += rnd(0.04, 0.06);
            },
        }),
        new Item({
            name: "The Shining",
            description: "Jack Torrance's new job at the Overlook Hotel is the perfect chance for a fresh start. But the idyllic location feels ever more remote... and more sinister.",
            category: ItemCategoryEnum.Books,
            have: $book_shining,
            price: 9.99,
            buy: () => { $book_shining = true; $money -= 9.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $culture += rnd(0.04, 0.06);
            },
        }),
        new Item({
            name: "Meditation for Beginners",
            description: "You already know how to close your eyes, breathe, and not think. But doing all three at the same time transcends you to a higher dimension of awareness.",
            category: ItemCategoryEnum.Books,
            have: $book_meditation,
            price: 7.99,
            buy: () => { $book_meditation = true; $money -= 7.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $meditation += rnd(0.09, 0.11);
            },
        }),
        new Item({
            name: "How to Weld",
            description: "Textbook covering everything from basics to advanced methods of welding.",
            category: ItemCategoryEnum.Books,
            have: $book_welding,
            price: 28.99,
            buy: () => { $book_welding = true; $money -= 28.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $welding += rnd(0.07, 0.11);
            },
        }),
        new Item({
            name: "Boost Your Confidence",
            description: "Stop being nervous, shy and insecure. The book will teach you how to be more confident.",
            category: ItemCategoryEnum.Books,
            have: $book_confidence,
            price: 8.99,
            buy: () => { $book_confidence = true; $money -= 8.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $confidence += rnd(0.05, 0.06);
            },
        }),
        new Item({
            name: "Cooking 101",
            description: "Learn fundamental techniques and tools used in the kitchen to prepare basic meals well.",
            category: ItemCategoryEnum.Books,
            have: $book_cooking,
            price: 5.99,
            buy: () => { $book_cooking = true; $money -= 5.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $basic_cooking += rnd(0.05, 0.06);
            },
        }),
        new Item({
            name: "Ancient Greece",
            description: "A book on greek history.",
            category: ItemCategoryEnum.Books,
            have: $book_history,
            price: 19.99,
            buy: () => { $book_history = true; $money -= 19.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $culture += rnd(0.05, 0.06);
            },
        }),
        new Item({
            name: "Smarter Every Day",
            description: "Learn how to improve your congitive abilities and increase brain power.",
            category: ItemCategoryEnum.Books,
            have: $book_iq,
            price: 12.99,
            buy: () => { $book_iq = true; $money -= 12.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $iq += rnd(0.05, 0.06);
            },
        }),
        new Item({
            name: "Speak Up!",
            description: "Tips and tricks to get better at public speaking.",
            category: ItemCategoryEnum.Books,
            have: $book_speak,
            price: 16.99,
            buy: () => { $book_speak = true; $money -= 16.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $public_speaking += rnd(0.05, 0.06);
                $people_skills += rnd(0.01, 0.02);
                $confidence += rnd(0.01, 0.02);
            },
        }),
        new Item({
            name: "Encyclopedia Britannica",
            description: "Facts about everything.",
            category: ItemCategoryEnum.Books,
            have: $book_encyclopedia,
            price: 44.99,
            buy: () => { $book_encyclopedia = true; $money -= 44.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $iq += rnd(0.04, 0.08);
                $culture += rnd(0.04, 0.07);
            },
        }),
        new Item({
            name: "Civil law",
            description: "Civil law is the legal system used in most countries around the world today. In civil law the sources recognised as authoritative are... zzz",
            category: ItemCategoryEnum.Books,
            have: $book_law,
            price: 32.95,
            buy: () => { $book_law = true; $money -= 32.95},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $basic_law += rnd(0.05, 0.06);
            },
        }),
        new Item({
            name: "Parla Italiano",
            description: "Build vocabulary so you can curse like an italian chef.",
            category: ItemCategoryEnum.Books,
            have: $book_italian,
            price: 7.95,
            buy: () => { $book_italian = true; $money -= 7.95},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $italian += rnd(0.05, 0.06);
            },
        }),
        new Item({
            name: "Language of Love",
            description: "Definitive guide on how to seduce non-french speakers.",
            category: ItemCategoryEnum.Books,
            have: $book_french,
            price: 15.95,
            buy: () => { $book_french = true; $money -= 15.95},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $french += rnd(0.05, 0.06);
            },
        }),
        new Item({
            name: "How to Manipulate People",
            description: "Power of suggestion. Body language. Eye contact. Master the skill of non-verbal communication.",
            category: ItemCategoryEnum.Books,
            have: $book_peopleskills,
            price: 21.99,
            buy: () => { $book_peopleskills = true; $money -= 21.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $people_skills += rnd(0.05, 0.06);
                $confidence += rnd(0.01, 0.03);
            },
        }),
        new Item({
            name: "Adventures Of Sherlock Holmes",
            description: "A collection of twelve detective stories of Sir Arthur Conan Doyle's most famous literary creation, Sherlock Holmes.",
            category: ItemCategoryEnum.Books,
            have: $book_sherlock,
            price: 6.99,
            buy: () => { $book_sherlock = true; $money -= 6.99},
            effect: () => {
                $energy -= rnd(0.15, 0.18);
                $iq += rnd(0.04, 0.05);
                $police_experience += rnd(0.01, 0.02);
                $people_skills += rnd(0.01, 0.02);
                $honesty += rnd(0.02, 0.03);
                $culture += rnd(0.02, 0.03);
            },
        }),
    ]

    function getNextDay(day) {
        var next_day = new Date(day);
        next_day.setDate(next_day.getDate() + 1);
        return next_day;
    }

    const addEvent = (name, date) => {
        $upcomingEvent = [...$upcomingEvent, {
            name: name,
            date: date,
        }];
    };

    const activateItem = (item) => {
        progressTime();
        withActionLog(item.name, item.effect);
    }

</script>



{#if !home}
    <shop-pad>
    {#each items as item}
        {#if item.category === currentShop}
            <sl-card>
                <columns>
                    <col-1 style="background-image: url('https://www.freevector.com/uploads/vector/preview/29298/girlcat-01.jpg')">
                    </col-1>
                    <col-2>
                        <strong>{item.name}</strong>
                        {#if item.price > 0}<sl-badge class='price' type="info" pill>${item.price}</sl-badge>{/if}
                        <br>
                        <small>{item.description}</small><br>
                        <sl-button disabled={(!(item.price <= $money) || item.have) || undefined}
                                   class="medium"
                                   on:click="{item.buy}"
                        >
                            {#if item.have}
                                Already have it
                            {:else if !(item.price <= $money)}
                                Not enough money
                            {:else}
                                Buy
                            {/if}
                        </sl-button>
                    </col-2>
                </columns>
            </sl-card>
        {/if}
    {/each}
    </shop-pad>
{:else}
    {#each items as item}
        <!-- HOME -->
        {#if item.have}
            {#if item.possible}
                <sl-tooltip content="{item.description}">
                    <sl-button class="item" on:click="{() => activateItem(item)}">
                        <button-img style="background-image: url('/img/{item.icon_url}'); background-size: cover;"></button-img>
<!--                        <sl-icon src="/img/{item.icon_url}" style="font-size: 3rem; line-height: 3rem;"></sl-icon>-->
                    </sl-button><br>
                </sl-tooltip>
            {:else}
                <sl-tooltip content="Not enough energy">
                    <sl-button class="item" disabled>
                        <button-img style="background-image: url('/img/{item.icon_url}'); background-size: cover;"></button-img>
<!--                        <sl-icon src="/img/{item.icon_url}" style="font-size: 3rem; line-height: 3rem;"></sl-icon>-->
                    </sl-button><br>
                </sl-tooltip>
            {/if}
        {/if}
    {/each}
{/if}


<style>
    shop-pad {
        display: block;
        padding: 0em 0.3em 0 0.4em;
    }
    sl-card {
        width: 100%;
        margin-bottom: 1em;
    }
    sl-badge {
        position: absolute;
        right: 1em;
    }
    columns {
        display: flex;
    }
    col-1 {
        flex-grow: 1;
        flex-basis: 33%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
    col-2 {
        padding-left: 1em;
        flex-grow: 2;
        flex-basis: 66%;
    }

    :root {
        --sl-input-height-medium: none;
    }
    sl-button.item {
        width: 4em;
        min-width: 4em;
        height: 4em;
        min-height: 4em;
    }
    button-img {
        height: 60px;
        width: 60px;
        display: block;
    }
</style>